import React, { useCallback, useContext, useEffect, useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { useNavigate } from "react-router";
import Step1 from "../../Components/LoginSteps/Step1";
import Step2 from "../../Components/LoginSteps/Step2";
import Step3 from "../../Components/LoginSteps/Step3";
import { useAuth } from "../../Context/useAuth";
import { dataContext } from "../../Context/contextProvider";
import { observer } from "mobx-react";

const LoginPage = observer(() => {
  const [openSteps, setOpenSteps] = useState<boolean[]>([false, false, false]);
  const { init, getUser } = useAuth();
  const dataStore = useContext(dataContext);
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [currentDbKey, setCurrentDbKey] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    init();
  }, [dataStore, getUser, init]);

  useEffect(() => {
    const arr = [];
    for (let i = 0; i < 3; i++) {
      const isOpen: boolean = i <= currentStep - 1;
      arr.push(isOpen);
    }
    setOpenSteps(arr);
  }, [currentStep]);

  const hanldeStep1Complete = (serverUrl: string): void => {
    if (serverUrl) {
      setCurrentStep(2);
    }
  };

  const hanldeStep2Complete = (dbKey: string): void => {
    if (dbKey) {
      setCurrentDbKey(dbKey);
      setCurrentStep(3);
    } else {
      setCurrentStep(2);
      setCurrentDbKey("");
    }
  };

  const handleNavigateToMenu = (): void => {
    navigate("/menu");
  };

  const handleOnGoToLogin = useCallback((): void => {
    setCurrentStep(1);
  }, []);

  return (
    <>
      <div className="d-flex justify-content-center top-padding">
        <img className="big-logo" src="/assets/images/login-page-logo.png" alt="eSuite" />
      </div>
      {!!openSteps[0] && (
        <Collapse in={!!openSteps[0]}>
          <div>
            <Step1 onStepComplete={hanldeStep1Complete} />
          </div>
        </Collapse>
      )}
      {!!openSteps[1] && (
        <Collapse in={!!openSteps[1]}>
          <div>
            <Step2 onStepComplete={hanldeStep2Complete} onNavigateToLogin={handleOnGoToLogin} />
          </div>
        </Collapse>
      )}
      {!!openSteps[2] && (
        <Collapse in={!!openSteps[2]}>
          <div>
            <Step3 onNavigateToMenu={handleNavigateToMenu} onNavigateToLogin={handleOnGoToLogin} dbKey={currentDbKey} />
          </div>
        </Collapse>
      )}
    </>
  );
});

export default LoginPage;
